import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  USER_CALORIE_LOGS: {
    path: `${baseRoutes.userBaseRoutes}/user-calorie-logs`,
  },
  USER_CALORIE_DETAILS: {
    path: `${baseRoutes.userBaseRoutes}/user-nutrition-details`,
  },
};

export default accessRoute;
